// Journal notes, including questions to bring to the doctor (SPEC.md §4.3 notes, §9).
import { useDbQuery } from '../db/hooks';
import type { DbClient } from '../db/client';

export interface Note {
  id: string;
  noted_at: string;
  body: string;
}

export function useNotes() {
  const query = useDbQuery<Note>('SELECT id, noted_at, body FROM notes WHERE deleted_at IS NULL ORDER BY noted_at DESC', [], ['notes']);
  return { notes: query.data ?? [], isLoading: query.isLoading };
}

export function saveNote(db: DbClient, id: string | undefined, values: Omit<Note, 'id'>) {
  return id ? db.update('notes', id, values) : db.insert('notes', values);
}

export function deleteNote(db: DbClient, id: string) {
  return db.softDelete('notes', id);
}
